import { Container } from "@mui/material";
import ManagerCustomStatus from "../components/General/ManagerCustomStatus";

export default function SettingsLawsuitTaxStatus() {
  return (
    <Container maxWidth="lg">
      <ManagerCustomStatus
        scope="lawsuit_tax"
        title="Estados del Sistema"
        description="Catálogo general de estados propios. Hoy se usa en Títulos Electrónicos para indicar si un título está pago, pero puede reutilizarse desde otros módulos."
      />
    </Container>
  );
}
